export const labels = [
  { 
    key: 'title',
    nl : 'Welkom',
    en : 'Meditations'
  },
  { 
    key: 'main',
    nl : 'INLEIDING',
    en : 'HOME'
  },
  { 
    key: 'main.title_1',
    nl : 'EEN RUSTIGE RUIMTE',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.title_2',
    nl : `Dualistisch Mediteren`,
    en : 'DUALISTIC MEDITATION'
  },
  { 
    key: 'main.title_3',
    nl : 'Niet-Dualistisch Mediteren',
    en : 'NON DUALISTIC MEDITATION'
  },
  {
    key:'main.title.sub_1',
    nl: 'De aap uit de mouw',
    en: 'The body scan'
  },
  {
    key:'main.title.sub_2',
    nl: 'Aandacht als een zaklamp',
    en: 'The body scan'
  },
  {
    key:'main.title.sub_3',
    nl: 'Beste wensen',
    en: 'The body scan'
  },
  {
    key:'main.title.sub_4',
    nl: 'De piloot achter onze ogen',
    en: 'The body scan'
  },
  {
    key:'main.title.sub_5',
    nl: 'Het ongedaan maken van de onveranderlijke persoon',
    en: 'The body scan'
  },
  {
    key:'main.title.sub_6',
    nl: 'Richt je aandacht op je aandacht',
    en: 'The body scan'
  },
  {
    key:'main.title.sub_7',
    nl: 'Het concept is dood, leve het concept',
    en: 'The body scan'
  },
  {
    key:'intro.div_1',
    nl: 'Van harte welkom op deze website!',
    en: 'The body scan'
  },
  {
    key:'intro.div_2',
    nl: 'Ik wens jullie veel lees- en leerplezier!',
    en: 'The body scan'
  },
  {
    key:'intro.div_3',
    nl: 'Arne Goyvaerts',
    en: 'The body scan'
  },
  { 
    key: 'intro.paragraph_1',
    nl : 'Ze is in het leven geroepen om medemensen een digitale plek aan te bieden waar ze inspiratie kunnen opdoen in hun zoektocht naar rust via meditatie.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'intro.paragraph_2',
    nl : 'Ik raad je aan te beginnen bij een inleidende tekst waar twee verschillende soorten meditatie uit de doeken worden gedaan. Enerzijds heb je de **dualistische** meditatie, waar er een duidelijk onderscheid bestaat tussen een *persoon* die observeert en een *object* dat geobserveerd wordt, anderzijds heb je de **niet-dualistische** meditatie, waarbij er alleen een *bewustzijn* bestaat waarin alles tevoorschijn komt en weer verdwijnt. ',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'intro.paragraph_3',
    nl : 'Alle handvaten en technieken die zowel op deze website als tijdens workshops en sessies worden aangehaald bestaan reeds vele jaren en zijn elders ook ter beschikking. Hiermee wil ik duidelijk stellen dat ik mij niet profileer als iemand die een revolutionaire aanpak hanteert. Er is een hele pagina gewijd aan het bronmateriaal dat ik heb mogen gebruiken om te staan waar ik vandaag sta maar omdat die informatie bijna volledig in het Engels is, wou ik die graag, weliswaar in beknopte vorm, in het Nederlands ter beschikking stellen. ',
    en : 'A QUIET PLACE'
  },
  {
    key:'intro.button',
    nl: 'NAAR DE INLEIDING',
    en: 'The body scan'
  },
  { 
    key: 'main.paragraph_2',
    nl : 'Bij een dualistische meditatie bestaat er een onderscheid tussen een mediteerder, *onderwerp*, en het richtpunt van de aandacht van die mediteerder, *object*. Men spreekt van **een onderwerp als de persoon die de wereld ervaart bestaande uit objecten die anders zijn dan de persoon die er naar kijkt**. Dit is een belangrijk onderscheid waar we later bij de niet-dualistische meditatie op terugkomen. Een basismeditatie om mensen tot het mediteren te introduceren bestaat erin zich uitzonderlijk te richten op de eigen ademhaling. Een beschrijving hiervan is toegankelijk via de knoppen die je hier en daar in de tekst zal tegenkomen.  Deze zijn volledig optioneel, dus als je wil kan je de hele uitleg doorlezen, zonder de meditatievoorbeelden. ',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_3',
    nl : 'Of je dit al reeds ooit elders gedaan hebt of het nu net even hebt geprobeerd, je zal ondervonden hebben dat het heel moeilijk is om de aandacht bij je ademhaling te houden. Nog voor je de vierde ademhaling geobserveerd hebt dwalen de gedachten af. De oefening bestaat erin de weg terug te vinden naar je ademhaling. Belangrijk hierbij is dat je **niet kwaad** of **gefrustreerd** raakt wanneer de gedachten afdwalen, dat doen ze namelijk altijd, zoals een aapje dat van tak naar tak springt. Men spreekt niet voor niets over *the monkey mind*.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_4',
    nl : 'Bewust ondervinden dat we doorheen ons leven constant nadenken en dat we door onze gedachten in het rond worden gestuurd is immers een heel belangrijke stap om ons welzijn in het dagdagelijks leven aanzienlijk te vergroten. Moet dat aapje getemd worden om ons vooruitgang te laten boeken, of moet er mogelijk iets anders mee gebeuren? Eerst en vooral moet ernaar gekeken worden. Door ernaar te kijken gebeurt er namelijk iets heel frappant: gedachten kunnen ook verdwijnen wanneer het aapje bij wijze van spreken aan kracht verliest. Kan je werkelijk meegevoerd worden door iets dat je observeert? Leer afstand creëren tussen *je gedachtegang* en *jezelf*, het onderwerp van je wereldse bestaan, en **zie in dat jij en je gedachten niet één geheel vormen**. Leer aan de oever staan van de rivier waardoor je gedachten stromen. Wanneer we onze gedachtegang op die manier in kaart leren brengen, kunnen we de vruchten hiervan bijna dagelijks plukken. Dat gebeurt natuurlijk niet van de ene dag op de andere. Oefening baart kunst, dus het is aangewezen om dagelijks 20 minuten jezelf af te zonderen en je op het mediteren toe te leggen. Hopelijk worden deze momenten welgekomen rustpunten in drukke dagen. Hopelijk, want aanvankelijk zal verleiding tot frustratie niet ver weg zijn.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_5',
    nl : 'Concentratievermogen kan nog verder gecultiveerd worden doormiddel van een **bodyscan**. Hierbij gebruiken we onze aandacht als een zaklamp waarmee we verschillende onderdelen van ons lichaam belichten terwijl we proberen onze aandacht erbij te houden. Ook hier is het van uiterst belang dat we ons **niet zenuwachtig maken** wanneer we merken dat we na een tijdje zijn afgedwaald. Gedachten zijn als haken die hun uiterste best doen om je aandacht met hen mee te voeren. Het is *onvermijdbaar* dat hen dat soms lukt. Kijk naar de gedachte die je heeft meegevoerd en ervaar dan wat er met die gedachte gebeurt. ',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_6',
    nl : 'Een volgende grote pijler is wat in het Engels de **lovingkindness** meditatie heet, ook wel bekend als **metta**. Hierbij wordt het concentratievermogen nogmaals aangesproken om bij wijze van spreken liefde en oprecht goede wensen door te sturen naar andere mensen. Er wordt ogenschijnlijk beroep gedaan op onze goede wil en we worden gemotiveerd om met mededogen naar onze medemens te kijken, of we die nu geweldig, gewoontjes of degoutant vinden. Voor we hierover verder gaan, is er eerst een verduidelijking aan de orde: Wat is mededogen en waarom staat er niet empathie? Er is een duidelijk onderscheid tussen de twee die vaak over het hoofd wordt gezien. **Empathie** is het kijken naar andere mensen waarbij men **mee voelt met de gevoelens van de andere**, hierdoor wordt onze eigen emotionele keuken potentieel overhoop gehaald, vooral wanneer men geconfronteerd wordt met een zwaar emotioneel lijden van iemand anders. **Mededogen** daarentegen, is het **erkennen van een ander zijn gevoel**, waarbij we actief streven naar het welzijn van de medemens, zonder de gevoelens tot zich te nemen. Dat is een groot stuk van het metta-verhaal. ',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_7',
    nl : 'Iedereen heeft wel eens gehoord van de uitspraak: *Je moet eerst jezelf graag kunnen zien, vooraleer je een ander graag kan zien*. Zo ook begint metta bij jezelf. Vooraleer we onze liefdevolle aandacht richten op iemand anders, richten we die eerst naar onszelf. De voorbeeldmeditatie die hier beschreven is, is zowel toepasbaar op onszelf, op iemand die je graag ziet, op iemand waar je neutraal tegenover staat en, ten slotte, iemand waar je eerder negatief naar kijkt. Vaak wordt ook die volgorde gevolgd, gespreid over meerder meditaties over een lange periode. Telkens wordt ons mededogen gecultiveerd zodat we realiseren dat wanneer we bijdragen tot een anders geluk, we er zelf ook gelukkig van worden.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_8',
    nl : 'De verzameling van afleidingen waarmee we tijdens het mediteren geconfronteerd worden: de afdwalende gedachten, de luide ademhaling van onze buurman wanneer je in groep mediteert, de pijn in de rug… kan je beschouwen als een deur naar het non-dualisme. *Het onderwerp-loos mediteren*. Het inzicht dat wij als mensen geen gedachten vormen maar dat ze zomaar tevoorschijn komen en weer verdwijnen, je het niet te kiezen hebt wat je aangenaam en onaangenaam vindt, op wie je verliefd wordt, welke onderwerpen je interessant vindt of de letters die je nu leest niet te ontcijferen als de taal die je ooit, lang geleden, geleerd hebt. Je begrijpt wat hier staat en er is niets dat je kan doen om die knop nu uit te schakelen. Je kan het niet *niet* lezen.  Bijgevolg is er ten gronde ons niets eigen. Niet je drie favoriete films die je opsomt wanneer de vraag gesteld wordt, niet je favoriete eten en niet de naam die je kiest voor je kinderen of je huisdieren. Sterker nog: je **ik**, *de ervaarder der ervaringen*, ja, jij die dit leest en tot zich neemt, bestaat eigenlijk helemaal niet.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_9',
    nl : 'Gezien het gewicht van deze stelling nu even een korte pauze voor contemplatie.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_10',
    nl : 'Nu rijst de vraag: is dit de grootste zever die ik ooit in mijn leven gelezen heb? Zijn mijn gedachten dan niet van mij? Ik heb toch te kiezen wat mijn favoriete films zijn, welke naam ik de mooiste vind en welk eten ik het lekkerste vind? Ik ben wel **iemand**. Niet?',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_11',
    nl : 'Nee, eigenlijk niet. Sorry.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_12',
    nl : 'Waar de reeds doorploegde uitleg hopelijk relatief makkelijk te volgen was, komen we nu in het territorium van de totale verwarring, abstracte stellingen en (nog meer) metaforen die je rond de oren vliegen. Ben je tot hier geraakt, dikke proficiat, doe je gordel om en bereid je voor om een paar dingen te herlezen, af en toe vaag voor je uit te staren en emotionele opwellingen van totale ontkenning te ondergaan. ',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_13',
    nl : 'Ieders ervaring van de wereld is verschillend. Ik kan niet in jullie hoofd kruipen en ondervinden hoe jullie de wereld ervaren, net zoals jullie dat niet bij mij kunnen. Toch denk ik dat de ervaring van een piloot achter onze ogen redelijk universeel is. Van achter je ogen interpreteer je de wereld, van daaruit worden de meningen gevormd, de geluiden opgevangen, de rozengeur geroken en daar worden de conversaties gevoerd, al dan niet met een andere persoon.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_14',
    nl : 'De piloot voelt zich aangesproken bij een belediging, zal blozen bij een genante ervaring en zich daar slecht over voelen en zal soms urenlang boos zijn over een situatie. De piloot is met andere woorden het **ik**. Ergens altijd veranderlijk maar toch ook wel onveranderlijk want je bent alleen zoals jij bent, reageert alleen zoals jij reageert en doet alleen de dingen die jij zelf als waardevol beschouwt. Soms wijken we van dat beeld af en dan wordt of doet iemand ‘anders’. Hopelijk is dat dan maar voor even want we kunnen immers nooit echt helemaal veranderen, nietwaar?',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_15',
    nl : 'Mocht je totaal nieuw zijn in de wereld van meditatie, net gehoord hebben van de rivierenmetafoor, de aap die in het rond springt of de gedachten die als haken zijn, dan volgt er nu misschien wel een stuk waardoor je het hele project links wil laten liggen. Ik nodig je uit om dat niet te doen. Toen ik voor het eerst werd geconfronteerd met deze manier van naar het leven kijken vond ik het een volstrekt belachelijk idee. Ik voelde mij bijna beledigd. Ook waren de meditaties zo vaag en frustrerend, dat ik vaak slechter gezind uit een meditatie stapte, wat al helemaal niet de bedoeling mag zijn. Ik hoop jullie van die valkuil te behoeden door erop te hameren dat naar élk gevoel of gedachte gekeken kan worden op een manier dat je er niet mee wordt meegetrokken. Zowel tijdens een meditatie als erbuiten kan je leren voelen wat er komt en kan je leren de ruimte te creëren die je nodig hebt om geen slaaf te zijn van de impulsen die in je opkomen.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_16',
    nl : 'Het goede nieuws is dat wat je zoekt bij non-dualisme, op de oppervlakte ligt te sluimeren. *Hidden in plain sight*, zoals men in het Engels zo mooi zegt. Het minder goede nieuws is dat ik moet proberen om een concept-loos bestaan te beschrijven, dat je als lezer dat ergens moet proberen begrijpen om tot de mogelijkheid te komen om het te ervaren. In de traditionele manier van handelen, is daar veel voorbereiding voor nodig en heb je een begeleider nodig die je actief kan ondersteunen tijdens je zoektocht. Dit is een tekst. De voorbereiding is erg summier, daar waar hierboven een erg beknopte uitleg staat wat dualistisch mediteren inhoudt. En niemand kan je vertellen of je goed bezig bent. Daarom is het vooral nu de bedoeling om je nieuwsgierigheid te prikkelen, je op weg te helpen naar een immens boeiende zoektocht naar je eigen natuur. Daarvoor moeten we nu ogenschijnlijk een bocht maken:',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_17',
    nl : 'In de pure essentie van het bestaan, is het dualistisch mediteren gebaseerd op een misvatting. Het is allemaal *fake*.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_18',
    nl : 'Herinner je de gedachtenrivier. De dualistische meditatie stelt je in staat om ernaar te kijken vanuit een piloot-achter-de-oren perspectief. Jij, *onderwerp-hoofdrolspeler*, kijkt naar je gedachten, *het object-het andere*, die tevoorschijn komen en je ziet ze ook terug verdwijnen. Je leert speling opbouwen tussen een **impuls** en een **reactie**, terwijl je concentratievermogen erop vooruit gaat. Win-win. Nu nodig ik je uit om na deze zin even weg te kijken en hier even bij stil te staan: *Waar komen die gedachten vandaan?* Probeer het proces te benoemen.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_19',
    nl : 'Gedachten komen en gaan. Hoelang ze blijven bestaan hangt af van hoe goed ze zijn in onze aandacht naar zich toe te trekken en bij hen te houden door veel emoties in ons los te maken. Een eerder negatieve gedachte die hierin uitblinkt kan ons doen piekeren en zo uren of zelfs dagen in het hoofd blijven spoken. Gelukkig staan we hier niet helemaal machteloos tegenover. Zoals eerder aangehaald kunnen we leren kijken naar de gedachte, wat vaak de levensduur  aanzienlijk zal inperken. Verder kunnen we ons toespitsen op het geboorteproces van een gedachte. Als individu heb je geen invloed op wat er tevoorschijn komt. Plots denken we wat we denken. Een gedachte komt, net zoals een geluid of een beeld, op ons af. ',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_20',
    nl : 'Hoe doe je dat, je aandacht richten op je aandacht? Ben jij niet je aandacht? Hoe kan jij, *onderwerp-hoofdrolspeler*, de aandacht richten op je eigen aandacht, *het object-het andere*?',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_21',
    nl : 'Het concept van **onderwerp-object-gebaseerde meditatie**, het dualistisch denken, begint hier onder druk te staan. Je kan niet vanuit een apart perspectief kijken naar je eigen perspectief.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_22',
    nl : 'Stel dat je aandacht vertrekt vanuit een punt in je hoofd. Daar waar de *ik* bestaat, de piloot achter de knoppen van je leven. Je gebruikt je aandacht als een zaklamp om daarmee iets in je omgeving te belichten. Je kijkt bijvoorbeeld naar deze tekst. Tegelijk ben je niet bezig met het gegeven of er al dan niet net een vogel een liedje aan het zingen is, tenzij die nu tegen je raam vliegt. Door het geluid van een vogel die tegen je raam vliegt, verplaatst je aandacht naar de oorsprong van het geluid. De vogel ligt roerloos op de grond en je begint je stilaan ongerust te voelen over zijn toestand. Gelukkig vindt de vogel terug zijn bewustzijn en kan hij opstijgen en verder gaan met zijn leven. Je voelt een golf van opluchting door je lichaam gaan. Wat een heftige rit.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_22.div_1',
    nl : 'Wat een heftige rit.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_22.div_2',
    nl : 'Het zou al handig zijn als je zou kunnen kijken naar de vloed van emoties die je soms kan ervaren en niet door het water wordt meegesleurd.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_23',
    nl : 'Stel nu dat het enige wat er bestaat aandacht is, of liever, **bewustzijn**. Je leest nog altijd deze tekst maar niet vanuit een bepaald punt dat ergens vertrekt vanuit je hoofd. De tekst komt *binnen*, net als alle andere objecten in je gezichtsveld. Het geluid van de botsende vogel komt ook binnen, het verschijnt in je bewustzijn in de vorm van een geluid. Je ongerustheid komt ook binnen, verschijnend als een gevoel dat je in je lichaam. Zo ook de opluchting. Dit is nog altijd een *gelaagde* manier van kijken naar het leven, daar waar we concepten blijven gebruiken om een vogel, tekst, geluid, gevoel en bewustzijn aan te duiden. Die geven het leven een context, waardoor we kunnen functioneren. Nu keren we terug naar de riviermetafoor, die nu klaar is voor een grondige aanpassing. Wat gebeurt er als we de observeerder van de rivier weg halen? Er is niemand om naar de rivier te kijken, geen hoofdpersonage, alleen een rivier. In deze metafoor *ben jij de rivier*. **Een constant veranderlijke stroom waar alles waar wij een concept voor hebben in voorbijgaat.**',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_24',
    nl : 'Ik heb jullie eerder uitgenodigd om het meditatieproject niet helemaal weg te gooien, nu nodig ik jullie uit om de mogelijkheid te overwegen dat datgene dat je ervaart als jezelf, die piloot in je hoofd die je eigenlijk niet echt kan aanduiden wanneer je hem zoekt, *ook* een concept is dat vooraf wordt gegaan door je bewustzijn, de eigenlijke poort waardoor je het leven ervaart. Een bepaalde strekking binnen de spirituele wereld maakt het onderscheid tussen **zelf** en **Zelf** of *self* en *Self*. De zelf zonder hoofdletter is *een concept dat we zelf maken* en wat versterkt wordt door je omgeving, de Zelf met de grote letter is de ervaring van het leven via het **pure bewustzijn**. Anderen spreken van een ik ervaring, waarbij *je aandacht wordt gericht als een zaklamp*, tegenover *een lamp die zichzelf verlicht*. Het is een lamp die de duisternis, de onwetendheid (dat befaamde woord **ignorance** dat je in meditatiekringen vaak hoort vallen), kan verdrijven. **Emptiness** is nog zo’n woord dat het Boeddhisme een nihilistisch kantje durft geven, naargelang de interpretatie van het woord. De *leegte*, is niet een leegte van het bestaan in de zin dat die zinloos zou zijn, het is de afwezigheid van conceptualisatie van de wereld rondom ons.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_25',
    nl : 'De eigenschappen die voorwerpen hebben, worden door *ons* gegeven, door *ons* in het bestaan geroepen. Dat wil niet zeggen dat je vanaf nu alle concepten weg moet gooien en conceptloos moet proberen bestaan. Het gaat er om het inzicht, of *herkenning*, ervan. Zie in dat je levenswereld opgebouwd is rond concepten, waarbij ook je *ik* een concept is dat gecreëerd is. Dat concept heb je in het dagelijkse leven nodig, hoe weet anders iemand dat jouw schoenen *jouw* schoenen zijn? De opdracht is je er niet mee te vereenzelvigen, want je *ik* sleurt je zo de dieperik in. **Samsara**, het steeds terugkeren van het verlangen voor iets dat je niet hebt, heeft hier ook een oorsprong in. Wil je uit dat systeem stappen, zie dan eerst en vooral in dat je *bewustzijn* de deur naar de realiteit is, **niet** je *ik*.',
    en : 'A QUIET PLACE'
  },
  
  { 
    key: 'main.paragraph_26',
    nl : 'Het concept van een concept-loos bestaan begrijpen is één ding, de ondervinding ervan is een ander. Het kan goed zijn dat er korte momenten zijn doorheen je dag waarin je merkt dat er een breuk ontstaat tussen hoe je de wereld vroeger ervaarde en nu. Soms wordt je leven schijnbaar geleefd, rafelt het voor je ogen af zonder dat je eigenlijk iets aan het doen bent, dan zijn er momenten die kunnen binnenkomen als diepe spirituele ervaringen. Je kan overvallen worden door een cascade-effect, waarbij je inziet dat het bewustzijn al hetgeen is dat er bestaat en je op onverklaarbare manier bij je hart terechtkomt en je jezelf verbonden voelt met alles en iedereen. Er komt een gevoel van warmte boven dat je uitdraagt naar iedereen rondom je. Het lijkt alsof je alles en iedereen graag ziet.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_27',
    nl : 'Op dat moment wordt er een blik  geworpen op je **ware natuur**. Onze ware natuur als mensen laat zich zien en voelen als een diepe naastenliefde. Allesomvattend mededogen. Vraag me nu niet waarom. Geen idee. Het is wat het is. Er zijn mensen geweest die het merendeel van hun leven doorbrachten in grotten, tot dit inzicht kwamen en dat uitdroegen naar hun omgeving. Anderen kijken naar een bloem en worden overvallen door de waarheid van het bestaan. Dit is niet eigen aan één levensvisie. Boeddhisme, Zen, Hindoeïsme, allen hebben ze een eigen versie van deze waarheid. Er is een **Ontwaken** en er is mogelijk een **Verlichting**. De *Verlichte* mens heeft de ervaring vanuit het bewustzijn om zo’n manier gestabiliseerd dat die daar *permanent* kan vertoeven. Wat er ook schijnbaar altijd bij hoort is dat deze mensen niet in de traditionele manier functioneren in de wereld. Zij moeten niet naar hun werk, hebben geen kinderen op te voeden en leven van de vrijgevigheid van anderen. Een *Ontwaakt* bestaan is iets anders. Hierbij ben je *in staat in te zien dat de realiteit anders is dan dat je dacht*, er is geen onderwerp dat objecten ervaart, maar je bent nog wel in staat om op een "maatschappelijk aanvaardbare manier" in het leven te staan. Je kan nog uit je lood geslagen worden, meegevoerd worden met een gedachtegang en soms diep ongeluk ervaren. Je hebt niet de stabiliteit die je kan doen dobberen op de golven van de zee van het leven, maar je hebt het wel ter beschikking als hulpmiddel, zolang je ernaar leert kijken.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.paragraph_28',
    nl : 'Proficiat, je bent aan het einde geraakt! Hopelijk is dit het begin of voortzetting van een boeiende reis en niet een abrupte botsing met De Muur Van Frustratie, Hoongelach En Bitterheid, of zoiets. Als je jezelf wil verdiepen in de materie kan je terecht bij het bronmateriaal en kan je de kalender raadplegen voor geplande workshops en sessies.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.quote_1',
    nl : 'Gedachten worden zoals dieven die een leeg huis komen plunderen, zelfs de mogelijkheid om afgeleid te worden houdt op met bestaan.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.quote_1_pt_2',
    nl : ' -Padmasambhava',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.quote_2',
    nl : 'Uiteindelijk komt gelukkig zijn neer op de keuze tussen het ongemak van het bewust te worden van je mentale kwalen en het ongemak om erdoor geregeerd te worden.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.quote_2_pt_2',
    nl : ' -Yongey Mingyur Rinpoche',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.quote_3',
    nl : 'Als je wil dat anderen gelukkig zijn, oefen in mededogen. Als je zelf gelukkig wil zijn, oefen in mededogen.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.quote_3_pt_2',
    nl : ' -Dalai Lama',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.quote_4',
    nl : 'Alles is verandering. Je kan niets blijven vasthouden. In de mate dat je met de stroming meegaat, merk je dat je geen weerstand hebt. In de mate dat je je tegen de stroom verzet, dan merk je dat de stroming voorbij raast en dat je ermee in gevecht gaat. Dus zwem mee, laat je meevoeren en dan ben je er.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.quote_4_pt_2',
    nl : ' -Alan Watts',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.quote_5',
    nl : 'Breng de rusteloze geest tot rust, alleen op dat moment zal je alles zien ontvouwen in leegte. ',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.quote_5_pt_2',
    nl : ' -Lao Tzu',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.quote_6',
    nl : 'Hoe meer je weet over jezelf, hoe helderder alles wordt. Zelf-kennis heeft geen einde, je bereikt niets, je komt niet tot een slot. Het is een eindeloze rivier.',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'main.quote_6_pt_2',
    nl : ' -Krishnamurti',
    en : 'A QUIET PLACE'
  },
  { 
    key: 'meditation.dual.vip1.title',
    nl : 'Ontdek Je Ademhaling',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip2.title',
    nl : 'Bodyscan',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip3.title',
    nl : 'Metta',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.nondual1.title',
    nl : 'Vind Je Held',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.nondual2.title',
    nl : 'Aandacht Voor Bewustzijn',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip1_1',
    nl : 'Sluit je ogen (nu nog niet)',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip1_2',
    nl : 'Richt de aandacht op je ademhaling',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip1_3',
    nl : 'Voel je buik op en neer gaan',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip1_4',
    nl : 'Probeer het tempo van je ademhaling niet te beïnvloeden',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip1_5',
    nl : 'Observeer',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip1_6',
    nl : 'Indien je merkt dat je gedachten zijn afgedwaald, keer je aandacht weer naar je ademhaling',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip1_7',
    nl : 'Doe dit gedurende 20 minuten (nu mag je de ogen sluiten)',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip2_1',
    nl : 'Sluit je ogen (nu nog niet)',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip2_2',
    nl : 'Probeer in je lichaam te komen door drie keer iets meer uitgesproken dan normaal uit te ademen',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip2_3',
    nl : 'Vestig je aandacht op het bovenste topje van je hoofd, je fontanel',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip2_4',
    nl : 'Laat je aandacht rustig afdalen, lange de wenkbrauwen, ogen, neus en mond',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip2_5',
    nl : 'Ga helemaal tot aan je voetzolen, waarbij elk stuk van je lichaam een moment van aandacht heeft genoten',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip2_6',
    nl : 'Raak je afgeleid, keer terug naar de plek waar je was en ga verder',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip2_7',
    nl : 'Probeer dit 20 minuten lang (nu mag je de ogen sluiten)',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip3_1',
    nl : 'Sluit je ogen (nu nog niet)',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip3_2',
    nl : 'Voel bewust je lichaam, hoe je contact maakt met je zitkussen of stoel',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip3_3',
    nl : 'Haal jezelf voor de geest, in de vorm van een beeld of gevoel',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip3_4',
    nl : 'Internaliseer de volgende zinnen, of spreek ze uit:',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip3_5',
    nl : 'Ik wens je geluk toe',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip3_6',
    nl : 'Ik wens je een lijdensvrij bestaan toe',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip3_7',
    nl : 'Ik wens je toe dat je bereikt wat je voor ogen hebt',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.dual.vip3_8',
    nl : 'Herhaal deze zinnen gedurende 15 minuten op een zo bewust mogelijke manier (nu mag je de ogen sluiten)',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.nondual1_1',
    nl : 'Haal je iemand voor de geest die je bewondert',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.nondual1_2',
    nl : 'Probeer het hele proces in kaart te brengen: ',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.nondual1_3',
    nl : 'Waarom heb je die persoon gekozen?',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.nondual1_4',
    nl : 'Hoe is die persoon in je opgekomen?',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.nondual1_5',
    nl : 'Kan je een mentaal beeld van die persoon lang vasthouden?',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.nondual1_6',
    nl : 'Gaat het beter als je ERG je best doet?',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.nondual2_1',
    nl : 'Kijk naar een object dat voor je ligt',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.nondual2_2',
    nl : 'Zo af en toe, maar voor korte periodes, probeer je aandacht te richten op het punt waaruit je aandacht vertrekt',
    en : 'SESSIONS'
  },
  { 
    key: 'meditation.nondual2_3',
    nl : 'Wanneer je afgeleid wordt door een emotie of een gedachte, richt je aandacht daarop en ervaar wat er gebeurt',
    en : 'SESSIONS'
  },
  { 
    key: 'sessions',
    nl : 'KALENDER',
    en : 'SESSIONS'
  },
  { 
    key: 'session.type_0',
    nl : '?',
    en : 'SESSIONS'
  },
  { 
    key: 'session.type_1',
    nl : 'sessie',
    en : 'SESSIONS'
  },
  { 
    key: 'session.type_2',
    nl : 'workshop',
    en : 'SESSIONS'
  },
  { 
    key: 'nosession.subject',
    nl : 'Deze kalender is helemaal leeg',
    en : 'SESSIONS'
  },
  { 
    key: 'nosession.description',
    nl : 'Op dit ogenblik zijn er geen sessies of workshops gepland. Wanneer mijn agenda het toelaat, zullen hier sessies met vaste regelmaat ingepland worden. Heb je interesse en wil je op de hoogte gehouden worden? Stuur een mailtje naar **arne.goyvaerts@gmail.com**  of word lid van [**deze facebookgroep**](https://www.facebook.com/groups/943650243458034).',
    en : 'SESSIONS'
  },
  { 
    key: 'session.subject.nondual.intro',
    nl : 'Introductie Niet-Dualistische Meditatie',
    en : 'SESSIONS'
  },
  { 
    key: 'session.description.nondual.intro',
    nl : 'Hier baseren we ons voornamelijk op de meditaties die afkomstig zijn uit de Vipassana traditie. Na een korte verwelkoming en voorstelronde beginnen we eerst met een praktijkoefening en volgen daarna deelcirkels, uitleg, meer oefeningen en een uitgebreide mogelijkheid om vragen te stellen.',
    en : 'SESSIONS'
  },
  { 
    key: 'session.subject.dual.intro',
    nl : 'Introductie Dualistische Meditatie',
    en : 'SESSIONS'
  },
  { 
    key: 'session.description.dual.intro',
    nl : 'We nemen afstand van onszelf en herontdekken de wereld door de blik van het bewustzijn. Ervaring in niet-dualistisch mediteren is niet verplicht maar wel erg handig bij deze sessie. Verwacht je aan veel denkwerk, meditatie, metaforen en nobele pogingen om net dat te benoemen wat niet te benoemen valt.',
    en : 'SESSIONS'
  },
  { 
    key: 'session.subject.meditation.recurring',
    nl : 'Groepsessie Meditatie',
    en : 'SESSIONS'
  },
  { 
    key: 'session.description.meditation.recurring_1hr',
    nl : 'Bij deze sessie doen we drie meditaties: twee van 20 minuten en een van 10, met telkens een korte pauze tussen. Zowel dualistisch als niet-dualistisch, telkens andere accenten en onderwerpen.',
    en : 'SESSIONS'
  },
  { 
    key: 'session.subject.meditation.recurring',
    nl : 'Groepsessie Mediatie',
    en : 'SESSIONS'
  },
  { 
    key: 'session.description.meditation.recurring_2hr',
    nl : 'Bij deze sessie doen we drie meditaties: twee van 20 minuten en een van 10, met telkens een korte pauze tussen. Zowel dualistisch als niet-dualistisch, telkens andere accenten en onderwerpen. Ruime tijd voor vragen en verdere uiteenzettingen na een deelcirkel.',
    en : 'SESSIONS'
  },
  { 
    key: 'session.month_1',
    nl : 'JANUARI',
    en : 'SESSIONS'
  },
  { 
    key: 'session.month_2',
    nl : 'FEBRUARI',
    en : 'SESSIONS'
  },
  { 
    key: 'session.month_3',
    nl : 'MAART',
    en : 'SESSIONS'
  },
  { 
    key: 'session.month_4',
    nl : 'APRIL',
    en : 'SESSIONS'
  },
  { 
    key: 'session.month_5',
    nl : 'MEI',
    en : 'SESSIONS'
  },
  { 
    key: 'session.month_6',
    nl : 'JUNI',
    en : 'SESSIONS'
  },
  { 
    key: 'session.month_7',
    nl : 'JULI',
    en : 'SESSIONS'
  },
  { 
    key: 'session.month_8',
    nl : 'AUGUSTUS',
    en : 'SESSIONS'
  },
  { 
    key: 'session.month_9',
    nl : 'SEPTEMBER',
    en : 'SESSIONS'
  },
  { 
    key: 'session.month_10',
    nl : 'OKTOBER',
    en : 'SESSIONS'
  },
  { 
    key: 'session.month_11',
    nl : 'NOVEMBER',
    en : 'SESSIONS'
  },
  { 
    key: 'session.month_12',
    nl : 'DECEMBER',
    en : 'SESSIONS'
  },
  { 
    key: 'session.day_1',
    nl : 'ZONDAG',
    en : 'SESSIONS'
  },
  { 
    key: 'session.day_2',
    nl : 'MAANDAG',
    en : 'SESSIONS'
  },
  { 
    key: 'session.day_3',
    nl : 'DINSDAG',
    en : 'SESSIONS'
  },
  { 
    key: 'session.day_4',
    nl : 'WOENSDAG',
    en : 'SESSIONS'
  },
  { 
    key: 'session.day_5',
    nl : 'DONDERDAG',
    en : 'SESSIONS'
  },
  { 
    key: 'session.day_6',
    nl : 'VRIJDAG',
    en : 'SESSIONS'
  },
  { 
    key: 'session.day_7',
    nl : 'ZATERDAG',
    en : 'SESSIONS'
  },
  { 
    key: 'sources',
    nl : 'BRONMATERIAAL',
    en : 'SOURCE MATERIAL'
  },
  { 
    key: 'source_1',
    nl : 'De Waking Up App kan je bijna beschouwen als de plek waar je alles vindt wat je maar nodig hebt. Je vindt er begeleide meditaties, conversaties, lessen en lezingen. Het geesteskind van schrijver Sam Harris heeft als doel om meditatie bij zoveel mogelijk mensen te krijgen. Er bestaat een boek met dezelfde naam die zeker ook de moeite is. Het is een betalende app, die ook een gratis versie ter beschikking stelt voor mensen die het zich niet kunnen verloorloven. De gebruikers van de app kunnen de app voor 1 maand gratis ter beschikking stellen voor anderen. Alle inhoud is in het Engels en vooral de conversaties vereisen een goede beheersing van de taal. Beschikbaar op Android, IOS en via de browser.',
    en : 'SOURCE MATERIAL'
  },
  { 
    key: 'source_2',
    nl : 'De beschrijving hoeft hier niet moeilijk te zijn, daar waar de titel perfect beschrijft waar het over gaat. Mocht je jezelf de vraag ooit gesteld hebben, dit boek zal je redenen genoeg geven om toch een poging te wagen. Matthieu Ricard is een Franse Boeddhistische monnik die ook zeer goede boeken geschreven heeft over onder andere dierenleed. Voor de liefhebbers is het boek ook beschikbaar in het Frans.',
    en : 'SOURCE MATERIAL'
  },
  { 
    key: 'source_3',
    nl : 'Ze hebben op het eerste zicht weinig met meditatie te maken maar psychedelica en meditatie hebben veel meer met elkaar gemeen dan dat je zou denken. Het boek dat mee voor de heropleving van deze substanties heeft gezorgd en maakte van schrijver Michael Pollan één van de voortrekkers van verantwoord gebruik, behoud van de ceremonie en een goed doordachte legalisering van o.a. psylocibine en ayahuasca. Naast de razend interessante inhoud, één van de best geschreven boeken die ik ooit heb mogen lezen. Netflix heeft hierover ook een documentaire serie met dezelfde naam.',
    en : 'SOURCE MATERIAL'
  },
  { 
    key: 'source_4',
    nl : 'Yongey Mingyur Rinpoche is al een tijdje abt van een klooster wanneer hij besluit om op een nacht de grote poort achter zich dicht te trekken en zonder enige bezitting buiten zijn kledij en de inhoud van zijn zakken de wijde wereld in te trekken. Een ‘dwalende retraite’, zoals hij dat noemt. Het zou zonde zijn om te verklappen wat er in dit boek gebeurt, maar ergens kan je het al raden. Mingyur Rinpoche is opgegroeid in zeer beschermde omstandigheden en voor hij deze expeditie ondernam, nog nooit onbegeleid buiten zijn klooster geweest. Het boek is een mooie introductie tot non-dualistisch denken. Ook zijn andere boeken ‘Joyful Wisdom’ en ‘Joy Of Living’ zijn aan te raden. Hij is de initiator van de Tergar Meditation Community.',
    en : 'SOURCE MATERIAL'
  },
  { 
    key: 'source_5',
    nl : 'Nadat hij verlamd werd door een plotse angst voor de dood, vroeg een jonge Ramana Maharshi zich af welk deel van zichzelf zou sterven, mocht hij komen te overlijden. Het antwoord op die vraag leidde hem naar de berg Arunachala waar hij het grootste deel van zijn leven zou doorbrengen. Daar werd hij door veel mensen omringd, zowel bezoekers als aanbidders. Who Am I is een korte tekst waarin het idee van een zelf en een Zelf op een overzichtelijke manier uit de doeken wordt gedaan in de vorm van vragen en antwoorden. Voor mensen met niet veel tijd en een hoge drang naar verlichting.',
    en : 'SOURCE MATERIAL'
  },
  { 
    key: 'source_6',
    nl : 'Alan Watts was, en is, een invloedrijk figuur die tijdens zijn leven de Oosterse filosofieën probeerde te introduceren in het Westen. Zijn lezingen zijn nog steeds immens populair en makkelijk te vinden. De Waking Up App stelt een uitgebreide verzameling van die lezingen beschikbaar voor haar gebruikers.  Eens je zijn stem hebt gehoord, merk je dat hij waarschijnlijk een van de meest geciteerde sprekers is die het internet rijk is. The Book gaat over persoonlijke identiteit en connectie, maatschappelijke uitdagingen en de onduurzaamheid van het Westerse wereldbeeld.',
    en : 'SOURCE MATERIAL'
  },  
  { 
    key: 'source_7',
    nl : 'Nisargadatta wordt vaak in een adem genoemd met Ramana Maharshi. Net zoals Who Am I, is I Am That een verzameling van dialogen die Nisargadatta voert met bezoekers en volgelingen van alle nationaliteiten. Non-dualisme staat centraal, volgens de visie van Advaita Vedanta. Zijn bedoeling was mensen te ontdoen van de illusie van een zelf en de introductie tot een Zelf. Voor mensen met veel tijd en een hoge drang naar verlichting, daar waar dit boek lijviger is dan Who Am I. ',
    en : 'SOURCE MATERIAL'
  },
  { 
    key: 'source_8',
    nl : 'Een praktijkboek voor niet-dualisme. Loch Kelly reisde de halve wereld af op zoek naar leraars die een verklaring konden geven voor een revelatie die Kelly als tiener onderging. Zelf beschouwt hij een niet-dualistische kijk naar de wereld als de volgende stap in de menselijke ontwikkeling aangezien het resultaat steeds mededogen en geluk zal zijn. Hij biedt ook online cursusse aan en organiseert ook retraites in de Verenigde Staten.',
    en : 'SOURCE MATERIAL'
  }, 
  { 
    key: 'source_9',
    nl : 'Voor de goede introductie tot Vipassana kan je terecht in het Dhamma Pajjota centrum in Dilsen waar je 10 dagen in stilte leert mediteren. Je mediteert ongeveer 11 uur per dag en krijgt elke avond een uiteenzitting van S.N. Goenka, die ondanks overleden te zijn in 2013, nog een grote invloed heeft op veel mensen. Het is een populaire bestemming dus het is aangewezen tijdig te reserveren. Geen vaste prijs, men werkt daar met vrijwillige brijdrage.',
    en : 'SOURCE MATERIAL'
  },  
  { 
    key: 'source_10',
    nl : 'Op de pagina van Tergar vind je online meditatiecursussen, gegeven door Yongey Mingyur Rinpoche. Dit traject is zeer uitgebreid en doet zijn best om meditatie zo toegankelijk mogelijk te maken door met vragenlijsten en videomateriaal te werken. Wel wordt er veel verwezen naar twee boeken: Joy Of Living en Joyful Wisdom, die je moet aanschaffen om helemaal op de hoogte te zijn. Je kan alles op je eigen tempo doen. De prijs bedraagt 25$/per maand.',
    en : 'SOURCE MATERIAL'
  },     
  { 
    key: 'source.button.link.app',
    nl : 'Naar de website',
    en : 'SOURCE MATERIAL'
  },
  { 
    key: 'source.button.link.book',
    nl : 'Naar het boek',
    en : 'SOURCE MATERIAL'
  },
  { 
    key: 'source.button.link.website',
    nl : 'Naar de website',
    en : 'SOURCE MATERIAL'
  },
  { 
    key: 'about',
    nl : 'Over Mij',
    en : 'ABOUT ME'
  },
  { 
    key: 'about.paragraph_1',
    nl : 'Mijn naam is Arne Goyvaerts. Gelukkig verloofd en vader van twee jonge kinderen, wonende in Mortsel, nabij Antwerpen. Om mijn kost te verdienen werk ik als IT-er. ',
    en : 'ABOUT ME'
  },
  { 
    key: 'about.paragraph_2',
    nl : 'Omdat mijn tienerjaren beheerst werden door faalangst en paniekaanvallen, ben ik op zoek gegaan naar een duurzame manier om hiermee om te gaan. Uiteindelijk ben ik bij meditatie terecht gekomen en dat is het enige dat na al die jaren is overgebleven. Het anders leren kijken naar gedachten en emoties geeft mij de ademruimte om als mens beter te functioneren en gelukkig te zijn. Daar waar er vaak enkel de nadruk gelegd wordt op mindfulness, wil ik graag een alternatief bieden dat het spectrum wat uitbreidt en daarom heb ik besloten een eerste stap te zetten met het maken van deze website. ',
    en : 'ABOUT ME'
  },
  { 
    key: 'about.paragraph_3',
    nl : 'Heb je vragen of opmerkingen over wat hier op de website te vinden is, wil je mij graag contacteren rond het organiseren van workshops of ben je geinteresseerd in de sessies, kan je altijd een mailtje sturen naar **arne.goyvaerts@gmail.com** of lid worden van [**deze facebookgroep**](https://www.facebook.com/groups/943650243458034).',
    en : 'ABOUT ME'
  },
  { 
    key: 'faq.title',
    nl : 'Mogelijke vragen',
    en : 'ABOUT ME'
  },
  { 
    key: 'faq.q1.question',
    nl : 'Ben jij een lineage holder?',
    en : 'ABOUT ME'
  },
  { 
    key: 'faq.q1.answer',
    nl : 'Nee dat ben ik niet. Een lineage holder is iemand die zijn/haar kennis vergaart dankzij transmissie van een meester, goeroe of iets dergelijks. Ik ben eerder een spons die hier en daar kennis en ervaring opdoet en al dan niet met wat geluk tot bepaalde inzichten komt. Ik besef dat dit niet veel voorstelt op een CV.',
    en : 'ABOUT ME'
  },
  { 
    key: 'faq.q2.question',
    nl : 'Wat mag het kosten?',
    en : 'ABOUT ME'
  },
  { 
    key: 'faq.q2.answer',
    nl : 'Ik ben te vinden voor een model met vrijwillige bijdrage. De insteek daar is dat je bijdraagt naarmate anderen baat zouden hebben bij een workshop of sessie. Bij een workshop op vraag wordt er over de prijs overlegd omdat er transportkosten komen bij kijken en het afhankelijk is van het aantal voorziene deelnemers. ',
    en : 'ABOUT ME'
  },
  { 
    key: 'random_question_1',
    nl : 'Wat onderscheidt een gedachte van een geluid dat je hoort? ',
    en : 'ABOUT ME'
  },
  { 
    key: 'random_question_2',
    nl : 'Wat onderscheidt een gedachte van een geur dat je opmerkt? ',
    en : 'ABOUT ME'
  },
  { 
    key: 'random_question_3',
    nl : 'Creëer je zelf je gedachten? ',
    en : 'ABOUT ME'
  },
  { 
    key: 'random_question_4',
    nl : 'Kijk eens naar je hand en vervolgens naar je pols. Waar eindigt je hand en begint een pols? Zou iedereen dezelfde plek aanduiden? ',
    en : 'ABOUT ME'
  },
  { 
    key: 'random_question_5',
    nl : 'Is de boom die je deze ochtend bent tegengekomen nog altijd dezelfde boom wanneer je hem later op de dag terug ziet? ',
    en : 'ABOUT ME'
  },
  { 
    key: 'random_question_6',
    nl : 'Waar begint en eindigt het concept boom, in de kruin, bij de wortels of nog ergens anders? ',
    en : 'ABOUT ME'
  },
  { 
    key: 'footer',
    nl : 'Zo aangenaam mogelijk gemaakt met Tailwind CSS en React',
    en : 'CONTACT'
  },
]